import { render, staticRenderFns } from "./ScwlOrderScrollBoard.vue?vue&type=template&id=10baa08a"
import script from "./ScwlOrderScrollBoard.vue?vue&type=script&lang=js"
export * from "./ScwlOrderScrollBoard.vue?vue&type=script&lang=js"
import style0 from "./ScwlOrderScrollBoard.vue?vue&type=style&index=0&id=10baa08a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports